const statuses = {
  'Allies': {
    class: 'pro',
    icon: '#icon-allies'
  },
  'Favorable': {
    class: 'complicated-pro',
    icon: '#icon-favorable'
  },
  'Complicated': {
    class: 'complicated',
    icon: '#icon-complicated'
  },
  'Unfavorable': {
    class: 'complicated-con',
    icon: '#icon-unfavorable'
  },
  'Adversaries': {
    class: 'con',
    icon: '#icon-adversaries'
  },
  'No Relationship of Note': {
    class: 'na',
    icon: '#icon-na'
  }
}

const getProp = (rel, prop) => {
  if (rel in statuses) {
    return statuses[rel][prop];
  }
  return statuses['N/A'][prop];
}

exports.statuses = statuses;
exports.getRelationshipIcon = (rel) => getProp(rel, 'icon');
exports.getRelationshipColor = (rel) => getProp(rel, 'class');
